(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-header';
  var section = document.querySelector(SECTION_SELECTOR);
  if (!section) return;

  /* ---------- DOM References ---------- */
  var menuToggle = section.querySelector('[data-menu-toggle]');
  var drawer = section.querySelector('[data-drawer]');
  var drawerPanel = drawer ? drawer.querySelector('.oddit-header__drawer-panel') : null;
  var drawerCloseButtons = section.querySelectorAll('[data-drawer-close]');
  var cartToggles = section.querySelectorAll('[data-cart-toggle]');
  /* Two tracks: one under the bar, one pinned in the mobile drawer. */
  var traitsTracks = section.querySelectorAll('[data-traits-track]');
  var drawerOverlay = section.querySelector('[data-drawer-overlay]');

  /* ---------- State ---------- */
  var isDrawerOpen = false;
  var focusTrapFirstEl = null;
  var focusTrapLastEl = null;
  var returnFocusEl = null;

  /* ---------- Drawer Open / Close ---------- */

  function openDrawer() {
    if (!drawer || isDrawerOpen) return;
    isDrawerOpen = true;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (menuToggle) {
      menuToggle.classList.add('is-active');
      menuToggle.setAttribute('aria-expanded', 'true');
    }

    /* Lock body scroll */
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';

    /* Save return focus element */
    returnFocusEl = document.activeElement;

    /* Set up focus trap */
    setupFocusTrap();

    /* Move focus into the dialog itself, not onto the close button.
       Focusing the button programmatically made Chrome paint the
       :focus-visible ring even when the drawer was opened by tap, so a purple
       halo sat on the X with no keyboard interaction involved. The panel
       carries tabindex="-1" and outline: none, which is the standard modal
       pattern: screen readers still announce the dialog, the trap below still
       cycles, and Tab moves to the close button where a ring is correct. */
    var panel = drawer.querySelector('.oddit-header__drawer-panel');
    if (panel) {
      panel.focus({ preventScroll: true });
    } else if (focusTrapFirstEl) {
      focusTrapFirstEl.focus();
    }
  }

  function closeDrawer() {
    if (!drawer || !isDrawerOpen) return;
    isDrawerOpen = false;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (menuToggle) {
      menuToggle.classList.remove('is-active');
      menuToggle.setAttribute('aria-expanded', 'false');
    }

    /* Unlock body scroll */
    document.body.style.overflow = '';
    document.body.style.touchAction = '';

    /* Return focus */
    if (returnFocusEl && typeof returnFocusEl.focus === 'function') {
      returnFocusEl.focus();
    }
    returnFocusEl = null;
  }

  function toggleDrawer() {
    if (isDrawerOpen) {
      closeDrawer();
    } else {
      openDrawer();
    }
  }

  /* ---------- Focus Trap ---------- */

  function setupFocusTrap() {
    if (!drawerPanel) return;
    var focusables = drawerPanel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (focusables.length === 0) return;
    focusTrapFirstEl = focusables[0];
    focusTrapLastEl = focusables[focusables.length - 1];
  }

  function handleFocusTrap(e) {
    if (!isDrawerOpen || !focusTrapFirstEl || !focusTrapLastEl) return;

    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === focusTrapFirstEl) {
          e.preventDefault();
          focusTrapLastEl.focus();
        }
      } else {
        if (document.activeElement === focusTrapLastEl) {
          e.preventDefault();
          focusTrapFirstEl.focus();
        }
      }
    }
  }

  /* ---------- Keyboard Handlers ---------- */

  function handleKeydown(e) {
    if (e.key === 'Escape' && isDrawerOpen) {
      closeDrawer();
    }
    handleFocusTrap(e);
  }

  /* ---------- Cart Integration ---------- */

  function openCart() {
    if (window.OdditCartDrawer && typeof window.OdditCartDrawer.open === 'function') {
      window.OdditCartDrawer.open();
    }
  }

  function onCartUpdated(e) {
    if (!e || !e.detail || !e.detail.cart) return;
    var cart = e.detail.cart;
    var badges = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = cart.item_count;
      if (cart.item_count > 0) {
        badges[i].classList.add('is-visible');
      } else {
        badges[i].classList.remove('is-visible');
      }
    }
  }

  /* ---------- Traits Band Marquee ---------- */

  function initTraitsMarquee() {
    if (!traitsTracks || traitsTracks.length === 0) return;

    for (var t = 0; t < traitsTracks.length; t++) {
      var track = traitsTracks[t];
      var items = track.children;
      if (items.length === 0) continue;

      /* Measure total width of one set of items (original, not clones) */
      var totalWidth = 0;
      for (var i = 0; i < items.length; i++) {
        totalWidth += items[i].offsetWidth;
      }

      /* Apply continuous scroll animation via CSS custom property */
      track.style.setProperty('--marquee-width', totalWidth + 'px');
    }
  }

  /* ---------- Event Bindings ---------- */

  /* Mobile drawer toggle */
  if (menuToggle) {
    menuToggle.addEventListener('click', toggleDrawer);
  }

  /* Drawer close buttons */
  for (var i = 0; i < drawerCloseButtons.length; i++) {
    drawerCloseButtons[i].addEventListener('click', closeDrawer);
  }

  /* Drawer overlay click to close */
  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', closeDrawer);
  }

  /* Keyboard (Escape + focus trap) */
  document.addEventListener('keydown', handleKeydown);

  /* Cart drawer toggle — all cart buttons (desktop + mobile) */
  for (var j = 0; j < cartToggles.length; j++) {
    cartToggles[j].addEventListener('click', function () {
      openCart();
    });
  }

  /* Cart count badge — listen for cart:updated from cart drawer JS */
  document.addEventListener('cart:updated', onCartUpdated);

  /* Traits band marquee */
  initTraitsMarquee();

  /* ---------- Theme Editor Lifecycle ---------- */

  function reinitSection(target) {
    var newSection = target.querySelector(SECTION_SELECTOR);
    if (!newSection) return;

    /* Update cached DOM references */
    section = newSection;
    menuToggle = section.querySelector('[data-menu-toggle]');
    drawer = section.querySelector('[data-drawer]');
    drawerPanel = drawer ? drawer.querySelector('.oddit-header__drawer-panel') : null;
    drawerCloseButtons = section.querySelectorAll('[data-drawer-close]');
    cartToggles = section.querySelectorAll('[data-cart-toggle]');
    traitsTracks = section.querySelectorAll('[data-traits-track]');
    drawerOverlay = section.querySelector('[data-drawer-overlay]');

    /* Rebind element-level listeners */
    if (menuToggle) {
      menuToggle.addEventListener('click', toggleDrawer);
    }
    for (var k = 0; k < drawerCloseButtons.length; k++) {
      drawerCloseButtons[k].addEventListener('click', closeDrawer);
    }
    if (drawerOverlay) {
      drawerOverlay.addEventListener('click', closeDrawer);
    }
    for (var m = 0; m < cartToggles.length; m++) {
      cartToggles[m].addEventListener('click', function () {
        openCart();
      });
    }

    /* Reset state */
    isDrawerOpen = false;

    initTraitsMarquee();
  }

  document.addEventListener('shopify:section:load', function (e) {
    reinitSection(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target.querySelector(SECTION_SELECTOR)) return;
    document.removeEventListener('keydown', handleKeydown);
    document.removeEventListener('cart:updated', onCartUpdated);
  });

})();